import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('AppLoading').create(({ theme }) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    width: '100%',
    background: theme.colors.background.primary,
    p: {
      color: theme.colors.text.primary,
      fontSize: '1.5rem',
    },
  },
}))
